import React, { useState, useEffect, useRef } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Pagination from "../General/Pagination";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import FeeSystemMenu from "./FeeSystemMenu";
import BanksDropDown from "../Shared/BanksDropDown";
import moment from "moment";
import * as XLSX from "xlsx";
import RightsCheck from "../General/RightsCheck";
import { Modal } from "react-bootstrap";

/** Match bank export / HTML-table headers with flexible naming. */
function scrollPickKey(row, candidateLabels) {
  if (!row) return null;
  const keys = Object.keys(row);
  const normalized = candidateLabels.map((c) =>
    c.toLowerCase().replace(/\s+/g, " ").trim()
  );
  for (const k of keys) {
    const nk = k.replace(/\s+/g, " ").trim().toLowerCase();
    if (normalized.includes(nk)) return k;
  }
  for (const lbl of normalized) {
    const found = keys.find((k) =>
      k.replace(/\s+/g, " ").trim().toLowerCase().includes(lbl)
    );
    if (found) return found;
  }
  return null;
}

function scrollCell(row, candidateLabels) {
  const key = scrollPickKey(row, candidateLabels);
  if (!key) return "";
  const v = row[key];
  return v == null ? "" : v;
}

function scrollParseMoney(v) {
  if (v == null || v === "") return NaN;
  const s = String(v)
    .replace(/\u00a0/g, " ")
    .replace(/,/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  const n = parseFloat(s);
  return n;
}

function scrollRowBench(row, fallbackBench) {
  const raw = scrollCell(row, ["Batch", "Bench", "Bench Number", "BenchNo", "BENCH"]);
  const n = parseInt(String(raw).trim(), 10);
  if (!Number.isNaN(n) && n > 0) return n;
  const fb = parseInt(String(fallbackBench || "").trim(), 10);
  return Number.isNaN(fb) ? 0 : fb;
}

/** Unposted list API may send PascalCase, camelCase, or challanNo. */
function displayChallanNoFromRow(item) {
  if (!item) return "";
  const v =
    item.Challan_No ??
    item.challan_No ??
    item.challanNo ??
    item.ChallanNo ??
    item["Challan_No"] ??
    item["challan_No"] ??
    "";
  return v === null || v === undefined ? "" : String(v);
}

function firstScrollField(item, ...keys) {
  if (!item) return "";
  for (const k of keys) {
    if (k in item && item[k] != null && String(item[k]).trim() !== "") {
      return String(item[k]).trim();
    }
  }
  return "";
}

/**
 * Parse bank sheet date/time (e.g. "4/7/2026  9:42:30 AM"), Excel serial, or Date → YYYY-MM-DD for API.
 * Avoids sending unparseable values that become 0001-01-01 in SQL Server.
 */
function parseBankSheetDateCell(raw, fallbackFormDate) {
  if (raw == null || raw === "") {
    const fb = (fallbackFormDate || "").toString().trim();
    if (!fb) return "";
    const mfb = moment(fb, ["YYYY-MM-DD", moment.ISO_8601], true);
    return mfb.isValid() ? mfb.format("YYYY-MM-DD") : "";
  }

  if (raw instanceof Date && !isNaN(raw.getTime())) {
    return moment(raw).format("YYYY-MM-DD");
  }

  // Excel serial (1900 date system): number of days since 1899-12-30
  if (typeof raw === "number" && !Number.isNaN(raw) && raw > 1) {
    const epochMs = Date.UTC(1899, 11, 30) + Math.round(raw * 86400000);
    const m = moment.utc(epochMs);
    if (m.isValid()) return m.format("YYYY-MM-DD");
  }

  const s = String(raw).trim().replace(/\s+/g, " ");
  const withTime = [
    "M/D/YYYY h:mm:ss A",
    "MM/D/YYYY h:mm:ss A",
    "M/DD/YYYY h:mm:ss A",
    "MM/DD/YYYY h:mm:ss A",
    "M/D/YYYY h:mm:ss a",
    "M/D/YYYY h:mm A",
    "MM/DD/YYYY h:mm A",
    "D/M/YYYY h:mm:ss A",
    "DD/M/YYYY h:mm:ss A",
    "D/M/YYYY h:mm:ss a",
    "D/M/YYYY h:mm A",
    "DD/MM/YYYY h:mm:ss A",
  ];
  const dateOnly = [
    "M/D/YYYY",
    "MM/D/YYYY",
    "M/DD/YYYY",
    "MM/DD/YYYY",
    "D/M/YYYY",
    "DD/M/YYYY",
    "D/M/YYYY",
    "DD/MM/YYYY",
    "YYYY-MM-DD",
    moment.ISO_8601,
  ];

  let m = moment(s, [...withTime, ...dateOnly], true);
  if (!m.isValid()) {
    const native = moment(new Date(s));
    if (native.isValid()) return native.format("YYYY-MM-DD");
  }
  if (m.isValid()) return m.format("YYYY-MM-DD");

  const fb = (fallbackFormDate || "").toString().trim();
  if (fb) {
    const mfb = moment(fb, ["YYYY-MM-DD", moment.ISO_8601], true);
    if (mfb.isValid()) return mfb.format("YYYY-MM-DD");
  }
  return "";
}

/** Maps bank Excel → tblScrollEntry.Dated (per-row). Bank column N: TransactionDate (then common aliases). */
function scrollRowDated(row, scrollDated) {
  const candidates = [
    "TransactionDate",
    "Transaction Date",
    "TRANSACTIONDATE",
    "DATED",
    "Dated",
    "Date",
    "Scroll Date",
  ];
  let cellRaw = null;
  for (const label of candidates) {
    const key = scrollPickKey(row, [label]);
    if (key) {
      const v = row[key];
      if (v != null && String(v).trim() !== "") {
        cellRaw = v;
        break;
      }
    }
  }
  const parsed = parseBankSheetDateCell(cellRaw, scrollDated);
  if (parsed) return parsed;
  return scrollDated && String(scrollDated).trim() !== ""
    ? scrollDated
    : "";
}

function AddBankScroll(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [isUpdated, setIsUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [TotalDeposited, setTotalDeposited] = useState("");
  const [ReceiptNo, SetReceiptNo] = useState("");
  const [ScrollDated, setScrollDated] = useState("");
  const [BenchNo, setBenchNo] = useState("");
  const [StudentId, setStudentId] = useState("");
  const [BarCodeValue, setBarCodeValue] = useState("");
  const [excelData, setExcelData] = useState([]);

  const [Amount_Deposited, setAmount_Deposited] = useState("");
  const [RegistrationNo, setRegistrationNo] = useState("");

  const [loadingPostEntries, setloadingPostEntries] = useState(false);
  const [fileSelected, setfileSelected] = useState(false);

  const [showFilters, setShowFilters] = useState(true);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(2000);
  const [totalRecords, setTotalRecords] = useState(0);

  const [selectedFileName, setSelectedFileName] = useState("");
  const [challanPreviewLoading, setChallanPreviewLoading] = useState(false);
  /** Rows from sheet import that did not save to tblScrollEntry (persists until cleared or new file). */
  const [sheetImportFailures, setSheetImportFailures] = useState([]);
  const sheetFileInputRef = useRef(null);

  /** Clears chosen file from DOM + state so sheet rows cannot be posted again by mistake. */
  const clearSheetImportFile = () => {
    if (sheetFileInputRef.current) {
      sheetFileInputRef.current.value = "";
    }
    setfileSelected(false);
    setExcelData([]);
    setSelectedFileName("");
  };

  useEffect(() => {
    document.title = "Add Bank Scroll";
    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/GetUnPostedEntries",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
        setTotalDeposited(response.data.TotalDeposited);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [pageNo, pageSize, isUpdated]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)} </td>
            <td>{displayChallanNoFromRow(item)}</td>
            <td>
              {item.Registration_No ||
                item.registration_No ||
                ""}
            </td>
            <td>{item.Student_Name}</td>
            <td>{item.Receipt_No}</td>
            <td>{item.BenchNumber}</td>
            <td>{moment(item.Dated).format("DD/MM/YYYY")}</td>
            <td className="text-center">{item.Amount_Deposited}</td>
            <td>
              {firstScrollField(
                item,
                "BankReceipt_ID",
                "bankReceipt_ID",
                "bankReceiptId"
              )}
            </td>
            <td>
              {firstScrollField(
                item,
                "Collection_Mode",
                "collection_Mode",
                "collectionMode"
              )}
            </td>
            <td className="text-center">
              <ul
                className="inline-action"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    onClick={(e) => deleteEntry(item.Entry_Id)}
                    className="red"
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </li>
              </ul>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="11">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };
  const deleteEntry = (ID) => {
    const result = window.confirm("Are you sure you want to delete?");

    if (result) {
      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        Entry_Id: ID,
      };

      var api_config = {
        method: "post",
        url: config.base_url + "ScrollEntry/DeleteScrollEntry",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          //console.log(response.data);
          if (response.data.status_code == 1) {
            setIsUpdated(true);
          }
          // setIsUpdated(false);
        })
        .catch(function (error) {
          //console.log(error);
        });
    }
  };

  const applyWorkbookToState = (workbook, displayName) => {
    if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
      throw new Error("No sheets in workbook");
    }
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(sheet);
    setfileSelected(true);
    setExcelData(jsonData);
    setSelectedFileName(displayName || "");
    setSheetImportFailures([]);
  };

  const handleFileChange = (event) => {
    const input = event.currentTarget;
    const file = input.files && input.files[0];

    if (!file || !(file instanceof Blob)) {
      if (input) input.value = "";
      setfileSelected(false);
      setExcelData([]);
      setSelectedFileName("");
      return;
    }

    const clearInput = () => {
      if (input) input.value = "";
      setfileSelected(false);
      setExcelData([]);
      setSelectedFileName("");
      setSheetImportFailures([]);
    };

    const tryReadAsText = () => {
      const textReader = new FileReader();
      textReader.onload = (ev) => {
        try {
          const workbook = XLSX.read(String(ev.target.result || ""), {
            type: "string",
          });
          applyWorkbookToState(workbook, file.name);
        } catch (err) {
          toast.error(
            "Could not read this file. For HTML-based .xls, save as .xlsx from Excel or re-export.",
            { position: toast.POSITION.TOP_RIGHT }
          );
          clearInput();
        }
      };
      textReader.onerror = () => {
        toast.error("File read failed.", { position: toast.POSITION.TOP_RIGHT });
        clearInput();
      };
      textReader.readAsText(file, "UTF-8");
    };

    const binReader = new FileReader();
    binReader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const head = String.fromCharCode.apply(
          null,
          Array.from(data.slice(0, Math.min(64, data.length)))
        );
        const looksLikeHtml =
          head.includes("<html") ||
          head.includes("<HTML") ||
          head.includes("<table") ||
          head.includes("<TABLE");

        if (looksLikeHtml) {
          tryReadAsText();
          return;
        }

        const workbook = XLSX.read(data, { type: "array" });
        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
          tryReadAsText();
          return;
        }
        applyWorkbookToState(workbook, file.name);
      } catch (err) {
        tryReadAsText();
      }
    };
    binReader.onerror = () => {
      toast.error("File read failed.", { position: toast.POSITION.TOP_RIGHT });
      clearInput();
    };
    binReader.readAsArrayBuffer(file);
  };

  /** Fetch next receipt for explicit bench + date (avoids stale state when prefilling filters). */
  const refreshReceiptNumber = (benchValue, datedValue) => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      BenchNumber: benchValue,
      Dated: datedValue,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/GetNextReceiptNumber",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          SetReceiptNo(response.data.receiptNumber);
        }
      })
      .catch(function (error) {
        //console.log(error);
      });
  };

  const GetNextReceiptNo = (benchInput) => {
    setBenchNo(benchInput);
    refreshReceiptNumber(benchInput, ScrollDated);
  };

  const ScanQRCode = (e) => {
    // if(e.target.value == 0) {
    //     setBarCodeValue("");
    // }
    // else {
    //     setBarCodeValue(e.target.value);
    // }

    setBarCodeValue(e.target.value);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      // Perform API call here
      if (BarCodeValue.length > 3) {
        postDataToAPI();
      } else {
        setBarCodeValue("");
      }
    }, 500);

    window.scrollTo(0, document.body.scrollHeight);

    return () => clearTimeout(delay);
  }, [BarCodeValue]);

  /** On focus out of Challan No: resolve challan and fill Amount for confirmation (ScrollEntry/GetChallanPreviewForScroll). */
  const handleChallanNoBlur = async () => {
    const no = (RegistrationNo || "").trim();
    if (!no || !AccessKey || !UserID) return;

    setChallanPreviewLoading(true);
    try {
      const res = await axios.post(
        config.base_url + "ScrollEntry/GetChallanPreviewForScroll",
        {
          UserID,
          AccessKey,
          MemberType,
          Challan_No: no,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      const d = res.data;
      if (d.status_code === 1) {
        const raw =
          d.suggested_amount !== undefined && d.suggested_amount !== null
            ? d.suggested_amount
            : d.suggestedAmount;
        if (raw !== undefined && raw !== null && raw !== "") {
          const n = Number(raw);
          if (!Number.isNaN(n)) {
            setAmount_Deposited(Number.isInteger(n) ? String(n) : String(n));
          }
        }
        // Add Entry requires scroll date + bench (server rejects bench 0). Filters say "optional"
        // but manual save needs them — prefill when missing so the button can enable.
        const datedStr = String(ScrollDated ?? "").trim();
        const benchStr = String(BenchNo ?? "").trim();
        const datedToUse =
          datedStr !== "" ? datedStr : moment().format("YYYY-MM-DD");
        const benchToUse = benchStr !== "" ? benchStr : "1";
        const filledMissingScrollFields = datedStr === "" || benchStr === "";
        if (datedStr === "") {
          setScrollDated(datedToUse);
        }
        if (benchStr === "") {
          setBenchNo(benchToUse);
        }
        // Only refetch receipt when we defaulted filters — avoids overwriting a manually typed receipt no.
        if (filledMissingScrollFields) {
          refreshReceiptNumber(benchToUse, datedToUse);
        }

        const sn = d.Student_Name || d.student_Name;
        const defaulted =
          filledMissingScrollFields
            ? " Date/bench were empty — using today's date and bench 1 (change under Show Filters if needed)."
            : "";
        toast.success(
          (sn
            ? `Amount set for ${sn} — confirm, then Add Entry.${defaulted}`
            : `Challan amount filled — confirm, then Add Entry.${defaulted}`),
          { position: toast.POSITION.TOP_RIGHT, autoClose: 3800 }
        );
      } else {
        toast.error(d.status_message || "Challan lookup failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (err) {
      toast.error("Could not load challan amount.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setChallanPreviewLoading(false);
    }
  };

  const postDataToAPI = () => {
    if (BarCodeValue != "" || BarCodeValue.length > 3) {
      const [challanPart, amountPart] = BarCodeValue.trim().split(/\s+/);

      const data = {
        UserID: UserID,
        AccessKey: AccessKey,
        MemberType: MemberType,
        BenchNumber: BenchNo,
        Dated: ScrollDated,
        Challan_No: (challanPart || "").trim(),
        Receipt_No: ReceiptNo,
        Amount_Deposited: amountPart,
      };
      var api_config = {
        method: "post",
        url: config.base_url + "ScrollEntry/AddScrollEntry",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          //  //console.log(response.data);
          if (response.data.status_code == 1) {
            setIsUpdated(true);
            setBarCodeValue("");
            setRegistrationNo("");
            setAmount_Deposited("");
            SetReceiptNo(parseInt(ReceiptNo) + parseInt(1));

            if (response.data.RegistrationNo != "") {
              toast.success(
                "Student has been registered with Registration No " +
                response.data.RegistrationNo,
                {
                  position: toast.POSITION.TOP_RIGHT,
                }
              );
            }
          }
          // setIsUpdated(false);
        })
        .catch(function (error) {
          //console.log(error);
        });
    } else {
      //console.log("here");
      // toast.error("Invalid QR code", {
      //     position: toast.POSITION.TOP_RIGHT
      // });
      setBarCodeValue("");
    }
  };

  const handleSubmit = () => {
    // Do not set BarCodeValue here — the BarCodeValue useEffect calls postDataToAPI (AddScrollEntry)
    // and would duplicate the request below.
    setLoading(true);

    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      MemberType: MemberType,
      BenchNumber: BenchNo,
      Dated: ScrollDated,
      Challan_No: (RegistrationNo || "").trim(),
      Receipt_No: ReceiptNo,
      Amount_Deposited: Amount_Deposited,
    };

    //console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/AddScrollEntry",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          setBarCodeValue("");
          SetReceiptNo(parseInt(ReceiptNo) + parseInt(1));
        } else if (
          response.data.status_code == 0 ||
          response.data.status_code == 2
        ) {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsUpdated(false);
        }
        setLoading(false);
        // setIsUpdated(false);
      })
      .catch(function (error) {
        //console.log(error);
        setLoading(false);
      });

    setAmount_Deposited("");
    setRegistrationNo("");
  };

  const handleSubmitByFile = async () => {
    if (!excelData || excelData.length === 0) {
      toast.error("No rows to import.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    setLoading(true);
    const failures = [];
    let receipt = parseInt(ReceiptNo, 10);
    if (Number.isNaN(receipt)) receipt = 0;

    const pushFailure = (rowIndex, row, partial) => {
      const challan = String(
        scrollCell(row, [
          "Challan Number",
          "Challan No",
          "CHALLAN NUMBER",
          "Challan_Number",
        ])
      ).trim();
      const mode = String(
        scrollCell(row, ["Collection Mode", "collection mode", "Collection_Mode"])
      ).trim();
      const bankReceipt = String(
        scrollCell(row, ["Receipt ID", "Receipt Id", "Receipt"])
      ).trim();
      failures.push({
        sheetRow: rowIndex + 1,
        challanNo: challan || "(missing)",
        dated: scrollRowDated(row, ScrollDated) || "",
        bench: scrollRowBench(row, BenchNo) || "",
        bankReceipt: bankReceipt || "",
        collectionMode: mode || "",
        amount: partial.amount != null ? String(partial.amount) : "",
        reason: partial.reason || "",
      });
    };

    for (let i = 0; i < excelData.length; i++) {
      const row = excelData[i];
      const challan = String(
        scrollCell(row, [
          "Challan Number",
          "Challan No",
          "CHALLAN NUMBER",
          "Challan_Number",
        ])
      ).trim();
      if (!challan) {
        failures.push({
          sheetRow: i + 1,
          challanNo: "(empty)",
          dated: scrollRowDated(row, ScrollDated) || "",
          bench: scrollRowBench(row, BenchNo) || "",
          bankReceipt: "",
          collectionMode: "",
          amount: "",
          reason: "No challan number in this row (skipped).",
        });
        continue;
      }

      const mode = String(
        scrollCell(row, ["Collection Mode", "collection mode", "Collection_Mode"])
      ).trim();
      const use1Bill = mode.toLowerCase() === "1bill";
      const colL = scrollParseMoney(
        scrollCell(row, [
          "Amount After DueDate",
          "Amount After Due Date",
          "Amount after duedate",
        ])
      );
      const colM = scrollParseMoney(
        scrollCell(row, ["Collected Amount", "Collected amount"])
      );
      let amount = use1Bill ? colL : colM;
      if (Number.isNaN(amount)) amount = use1Bill ? colM : colL;
      if (Number.isNaN(amount)) {
        pushFailure(i, row, {
          amount: null,
          reason: "No valid amount in row (check Collected Amount / Amount After Due Date).",
        });
        continue;
      }

      const bankReceipt = String(
        scrollCell(row, ["Receipt ID", "Receipt Id", "Receipt"])
      ).trim();

      const data = {
        UserID: UserID,
        AccessKey: AccessKey,
        MemberType: MemberType,
        BenchNumber: scrollRowBench(row, BenchNo),
        Dated: scrollRowDated(row, ScrollDated),
        Challan_No: challan,
        Receipt_No: receipt,
        Amount_Deposited: amount,
        BankReceipt_ID: bankReceipt || undefined,
        Collection_Mode: mode || undefined,
      };

      try {
        const response = await axios.post(
          config.base_url + "ScrollEntry/AddScrollEntry",
          data,
          { headers: { "Content-Type": "application/json" } }
        );
        if (response.data.status_code === 1) {
          setIsUpdated(true);
          receipt += 1;
          SetReceiptNo(String(receipt));
        } else {
          const msg =
            response.data.status_message || response.data.Status_Message || "Save failed";
          pushFailure(i, row, { amount, reason: msg });
          toast.error(`${challan}: ${msg}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 6000,
          });
        }
      } catch (error) {
        const msg =
          (error.response &&
            error.response.data &&
            (error.response.data.status_message ||
              error.response.data.message)) ||
          error.message ||
          "Network or server error";
        pushFailure(i, row, { amount, reason: msg });
        toast.error(`${challan}: ${msg}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 6000,
        });
      }
    }

    setSheetImportFailures(failures);
    setLoading(false);
    clearSheetImportFile();

    if (failures.length > 0) {
      toast.warn(
        `${failures.length} row(s) were not imported. See the list below to fix challans and re-import.`,
        { position: toast.POSITION.TOP_RIGHT, autoClose: 8000 }
      );
    } else {
      toast.success("All sheet rows imported successfully.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const PostEntries = () => {
    setloadingPostEntries(true);
    const benchParsed = parseInt(String(BenchNo || "").trim(), 10);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      BenchNo: Number.isNaN(benchParsed) ? 0 : benchParsed,
    };
    if (ScrollDated && String(ScrollDated).trim() !== "") {
      data.StartDate = ScrollDated;
    }

    var api_config = {
      method: "post",
      url: config.base_url + "ScrollEntry/PostEntriesIntoLedger",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
        }
        else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }

        setloadingPostEntries(false);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };

  const handleLiveData = () => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      Dated: ScrollDated,
      BenchNo: '100'
    };
    var api_config = {
      method: "post",
      url: config.base_url + 'FeeOrder/FetchDataFromServer',
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    }
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        toast.error(error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })

  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleMissingData = () => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ID: StudentId,

    };
    var api_config = {
      method: "post",
      url: 'https://api.nscholar.com/api/FeeOrder/JazzOrderInquiry',
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    }
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShow(false);
        }
        else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        toast.error(error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
  };


  return (
    <>


      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Get Missing Order Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="row align-items-center gy-3">
            <div className="col-md-12">
              <div className="form-group">
                <label for="">Enter Order ID</label>
                <input type="text" className="form-control" onChange={(e) => setStudentId(e.target.value)} />
              </div>
            </div>
            <div className="col-md-3">
              <button className="button button-primary" onClick={() => handleMissingData()}>Submit</button>
            </div>
          </div>

        </Modal.Body>

      </Modal>
      <RightsCheck />
      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add BankScroll
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Add BankScroll</div>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <button
                    onClick={() => {
                      setShowFilters((prevIsActive) => !prevIsActive);
                    }}
                    className="button button-white button-icon"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div
              className={`collapse ${showFilters ? "show" : ""} `}
              id="collapseFilteres"
            >
              <div>
                <div className="card mb-4">
                  <div className="card-body p-4">
                    <div className="row align-items-center">
                      <div className="col-md-3">
                        <div className="form-group">
                          <label for="">Select Branch:</label>
                          <select className="form-select" required>
                            <BanksDropDown />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <label>Dated (optional for list / post):</label>
                          <input
                            type="date"
                            className="form-control"
                            value={ScrollDated}
                            onChange={(e) => setScrollDated(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <label> Bench No (optional for list / post):</label>
                          <input
                            type="text"
                            className="form-control"
                            value={BenchNo}
                            onChange={(e) => GetNextReceiptNo(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="card">
                <div className="card-body">
                  <table className="table table-theme ">
                    <thead>
                      <tr>
                        <th>S No</th>
                        <th>Challan No</th>
                        <th>Registration No</th>
                        <th>Student Name</th>
                        <th>Receipt No</th>
                        <th>Bench No</th>
                        <th>Dated</th>
                        <th>Amount Deposited</th>
                        <th>Bank receipt ID</th>
                        <th>Collection mode</th>
                        <th className="text-center">Delete</th>
                      </tr>
                    </thead>
                    <tbody>{renderLedger()}</tbody>
                  </table>
                  {totalRecords > 10 && (
                    <div className="pagination-wrap">
                      <div className="row align-items-center">
                        <div className="col-md-2 form_default">
                          <div className="d-flex align-items-center">
                            <label
                              className="me-2"
                              style={{ fontSize: "15px" }}
                            >
                              Page Size
                            </label>
                            <div className="form-group">
                              <select
                                className="form-select"
                                style={{ width: "100px" }}
                                onChange={(e) => {
                                  setPageNo(1);
                                  setPageSize(parseInt(e.target.value));
                                }}
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="1000">1000</option>
                                <option value="2000" selected>2000</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <Pagination
                          pageNo={pageNo}
                          pageSize={pageSize}
                          totalRecords={totalRecords}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="card-footer text-end d-flex align-items-center justify-content-between">
                  <div>
                    <strong>{totalRecords}</strong> Records Found!
                  </div>
                  <div
                    className="d-flex align-items-center"
                    style={{ minHeight: "50px" }}
                  >
                    <h4 className="m-0 me-4">
                      Total Amount: <strong>{TotalDeposited}</strong>
                    </h4>
                    {loadingPostEntries ? (
                      <Spinner animation="border" role="status"></Spinner>
                    ) : (
                      <button
                        type="button"
                        onClick={PostEntries}
                        className="button button-primary"
                      >
                        Post Entries in Ledger
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Receipt No:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => SetReceiptNo(e.target.value)}
                        value={ReceiptNo}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3 position-relative">
                      {loading ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "20px",
                            top: "37px",
                          }}
                        >
                          <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                          ></Spinner>
                        </div>
                      ) : (
                        ""
                      )}
                      <label>BarCode Entry:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => ScanQRCode(e)}
                        value={BarCodeValue}
                        disabled={ScrollDated == "" ? true : false}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3 position-relative">
                      {challanPreviewLoading ? (
                        <div
                          style={{
                            position: "absolute",
                            right: "20px",
                            top: "37px",
                            zIndex: 1,
                          }}
                        >
                          <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                          ></Spinner>
                        </div>
                      ) : null}
                      <label>Challan No:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={RegistrationNo}
                        onChange={(e) => setRegistrationNo(e.target.value)}
                        onBlur={handleChallanNoBlur}
                        name="RegistrationNo"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group mb-3">
                      <label>Amount:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={Amount_Deposited}
                        onChange={(e) => setAmount_Deposited(e.target.value)}
                        name="Amount_Deposited"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row gy-3">
                  <div className="col-md-8">
                    {selectedFileName && (
                      <span style={{ fontSize: "13px", marginRight: "10px" }}>
                        Selected file: {selectedFileName}
                      </span>
                    )}
                  </div>

                  <div className="col-md-2 offset-md-2">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={
                        String(Amount_Deposited ?? "").trim() === "" ||
                        String(RegistrationNo ?? "").trim() === "" ||
                        String(ScrollDated ?? "").trim() === "" ||
                        String(BenchNo ?? "").trim() === ""
                      }
                      className={`button button-primary w-100
                       ${String(Amount_Deposited ?? "").trim() === "" ||
                          String(RegistrationNo ?? "").trim() === "" ||
                          String(ScrollDated ?? "").trim() === "" ||
                          String(BenchNo ?? "").trim() === ""
                          ? "disabled"
                          : ""
                        }`}
                    >
                      Add Entry
                    </button>
                  </div>
                  <div className="col-md-3">
                    <button className="button button-danger" onClick={handleLiveData}>Get Live Data</button>
                  </div>
                  <div className="col-md-3 offset-md-2 text-end">
                    <button className="button button-primary" variant="primary" onClick={handleShow}>
                      Get Missing Order Data
                    </button>
                  </div>
                  <div className="col-md-2">

                    <label
                      htmlFor="chose-file"
                      className="button button-white shadow-sm w-100"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="ri-upload-2-line"></i> Chose File
                      <input
                        id="chose-file"
                        ref={sheetFileInputRef}
                        style={{
                          opacity: "0",
                          zIndex: "-1",
                          visibility: "hidden",
                          position: "absolute",
                        }}
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                    </label>
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      onClick={handleSubmitByFile}
                      disabled={!fileSelected}
                      className={`button button-primary w-100
                       ${!fileSelected ? "disabled" : ""}`}
                    >
                      Add Enteries
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {sheetImportFailures.length > 0 ? (
              <div className="card mt-3 border-warning shadow-sm">
                <div className="card-header d-flex flex-wrap justify-content-between align-items-start gap-2 bg-warning bg-opacity-10 py-3">
                  <div>
                    <strong className="d-block">
                      Sheet import — not saved to bank scroll (
                      {sheetImportFailures.length})
                    </strong>
                    <span className="small text-muted">
                      These rows were skipped or rejected by the server (e.g.
                      challan not found). Fix the challan or row data, then
                      re-import or add entries manually. This list stays until
                      you clear it or choose a new file.
                    </span>
                  </div>
                  <button
                    type="button"
                    className="button button-white button-sm"
                    onClick={() => setSheetImportFailures([])}
                  >
                    Clear list
                  </button>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered table-theme mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Sheet row</th>
                          <th>Challan no</th>
                          <th>Amount</th>
                          <th>Dated</th>
                          <th>Bench</th>
                          <th>Bank receipt</th>
                          <th>Collection mode</th>
                          <th>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sheetImportFailures.map((f, idx) => (
                          <tr key={`${f.sheetRow}-${idx}-${f.challanNo}`}>
                            <td>{idx + 1}</td>
                            <td>{f.sheetRow}</td>
                            <td>{f.challanNo}</td>
                            <td>{f.amount}</td>
                            <td>{f.dated}</td>
                            <td>{f.bench}</td>
                            <td>{f.bankReceipt}</td>
                            <td>{f.collectionMode}</td>
                            <td className="text-start small">{f.reason}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default AddBankScroll;
